import React, { memo } from 'react';
import { receptionTableHeader as headers } from '../config';
import { TableRow, TableCell, TableText } from '@/shared/components/molecules/table.style';
import { formatDateRange } from '@shared/utils/common';
import ReceptionStatusBadge from './ReceptionStatusBadge';
import { CheckInListItemDto } from '@/api/generated/model/checkInListItemDto';

import type { CheckInListItemDtoStatus } from '@/api/generated/model';

type ReceptionListItemProps = {
	reception: CheckInListItemDto;
	onNavigate: (reception: CheckInListItemDto) => void;
};

// 리셉션 목록 행 (대회/프로그램 단위)
const ReceptionListItem = memo<ReceptionListItemProps>(({ reception, onNavigate }) => {
	return (
		<TableRow onClick={() => onNavigate(reception)}>
			<TableCell $minWidth={headers[0].minWidth} $width={headers[0].width}>
				<TableText>
					<ReceptionStatusBadge status={reception.status as CheckInListItemDtoStatus} />
				</TableText>
			</TableCell>
			<TableCell $minWidth={headers[1].minWidth} $width={headers[1].width}>
				<TableText>{formatDateRange(reception.startDate, reception.endDate, 'MM.DD HH:mm')}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[2].minWidth} $width={headers[2].width}>
				<TableText>{reception.title}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[3].minWidth} $width={headers[3].width}>
				<TableText>{reception.categoryName}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[4].minWidth} $width={headers[4].width}>
				<TableText>{reception.totalParticipants.toLocaleString()}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[5].minWidth} $width={headers[5].width}>
				<TableText>{reception.checkedInCount.toLocaleString()}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[6].minWidth} $width={headers[6].width}>
				<TableText>{reception.remainingCount.toLocaleString()}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[7].minWidth} $width={headers[7].width}>
				<TableText>{reception.progressRate}%</TableText>
			</TableCell>
		</TableRow>
	);
});

ReceptionListItem.displayName = 'ReceptionListItem';

export default ReceptionListItem;
